export const getPrevMonthDate = () => {
  const changingDate = new Date()
  changingDate.setDate(1)
  changingDate.setMonth(changingDate.getMonth() - 1)
  return changingDate
}
